export class Duration {
  readonly milliseconds: number;
  readonly seconds: number;
  readonly minutes: number;
  readonly hours: number;
  readonly isNegative: boolean;

  constructor(start: Date, end: Date) {
    if (start == null || end == null) {
      this.milliseconds = 0;
      this.seconds = 0;
      this.minutes = 0;
      this.hours = 0;
    } else {
      let time = end.valueOf() - start.valueOf();
      if (time < 0) {
        time *= -1;
        this.isNegative = true;
      } else {
        this.isNegative = false;
      }
      this.milliseconds = time % 1000;
      time = Math.floor(time / 1000);
      this.seconds = time % 60;
      time = Math.floor(time / 60);
      this.minutes = time % 60;
      this.hours = Math.floor(time / 60);
    }
  }
}
